
import * as antlr4 from 'antlr4ng';

// import { CohortDefinitionErrorListener } from './CohortDefinitionErrorListener';
import {CohortDefinitionLexer} from '../runtime/CohortDefinitionLexer';
import {CohortDefinition} from '../runtime/CohortDefinition';
import { CustomErrorListener } from '../errorHandlers/CustomErrorListener';

export const parseCohortDefinitionQuery = (query: string) => {
  // Standard ANTLR setup

  const chars = antlr4.CharStream.fromString(query);
  const lexer = new CohortDefinitionLexer(chars);
  const tokenStream = new antlr4.CommonTokenStream(lexer);
  
  /** Current Version */
  const cohortDefinitionParser = new CohortDefinition(tokenStream);

  // remove default error listeners, you can comment this out to get feedback directly from ANTLR
  lexer.removeErrorListeners();
  cohortDefinitionParser.removeErrorListeners();

  // add custom error listener
  const customErrorListener = new CustomErrorListener();
  cohortDefinitionParser.addErrorListener(customErrorListener)

  // initialize parse trees (this also fills the tokenStream)
  cohortDefinitionParser.buildParseTrees = true;
  const cohortDefinitionTree = cohortDefinitionParser.cohort_definition();

  // Future: add more error handling here
  // walk the tree and add parse tree listeners to add domain-specific logic

  return {
    tokenStream,
    cohortDefinitionParser,
    cohortDefinitionTree,
    customErrorListener,
  };
};

